/**
 * Só os dígitos do telefone, sem o DDI 55:
 * "(48) 99671-0304" | "+55 (48) 99671-0304" -> "48996710304".
 * O "55" só sai quando vem seguido de exatamente 11 dígitos (DDD + celular),
 * para não comer o DDD 55.
 */
export const onlyDigits = (phone: string): string =>
  phone.replace(/\D/g, "").replace(/^55(?=\d{11}$)/, "")
